// extracted by mini-css-extract-plugin
export default {"mapPage":"Map_mapPage__7R7bQ","locBtn":"Map_locBtn__XZklW","active":"Map_active__7z6O6","mapWrap":"Map_mapWrap__SCdK1","map":"Map_map__TBB+B","address":"Map_address__FzjUD"};